import * as breakpoint from '@pixelunion/breakpoint';

import FAQ from '@pixelunion/pxs-faq';

export default class DynamicFAQ extends FAQ {
  constructor(section) {
    super(section);
    this.el = section.el;

    this.allAnswerElements = this.el.querySelectorAll('[data-faq-answer]');

    this._onBreakpointChange = this._onBreakpointChange.bind(this);
    breakpoint.onChange(this._onBreakpointChange);
  }

  _resizeAnswerElements() {
    this.allAnswerElements.forEach(answersEl => {
      if (answersEl.dataset.animationState === 'open') {
        answersEl.style.setProperty('--open-height', 'auto');
      }
    });
  }

  _onBreakpointChange() {
    this._resizeAnswerElements();
  }
}
